import React from 'react';
import { Link } from 'react-router-dom'

import { Row, Col, Layout } from 'antd'

import Footer from '../../components/Footer/Footer'
import classes from './PhysicianScript.css'


const { Content } = Layout;


export default class Home extends React.Component {

    render() {
        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                                <Row type='flex' justify='center'>
                                    <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                                      <h2>Physician Script</h2>
                                        <p>You/Your loved one is having a stroke, caused by a blood clot in the brain. We will be giving you a clot-busting drug as soon as possible. The hope is that this drug will open up the blockage in your brain caused by the clot. The main risk of this drug is bleeding, which is rare; 5% chance or less, so there is at least a 95% chance that the drug will not harm you.</p>
                                        <p>Today, we [the ____________ Hospital] are participating in a clinical study in which the choice of which clot-busting drug you receive is determined by chance. This is intended to compare two different clot-busting drugs for patients like you having a stroke. Based on what we know so far, these two drugs are similar. You are guaranteed to receive one of the two drugs. For the sake of time, I will make sure you/your loved one gets the drug now and can answer more questions later. Here is an information sheet for you to read in the meantime.</p>
                                        <p>&nbsp;</p>
                                      <ul>
                                        <li><Link to='/' style={{ color: '#FAFAFA' }} className='menu-item'> Home </Link></li>
                                        <li><Link to='/patient-information-sheet' style={{ color: '#FAFAFA' }} className='menu-item'> Patient Information Sheet </Link></li>
                                        <li><Link to='/randomize' style={{ color: '#FAFAFA' }} className='menu-item'> Randomize </Link></li>
                                      </ul>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/PhysicianScript/PhysicianScript.js